import React from "react";

export const NumberListIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.83203 16.5833H4.66536V17.0417H3.7487V17.9583H4.66536V18.4167H2.83203V19.3333H5.58203V15.6667H2.83203V16.5833ZM3.7487 8.33334H4.66536V4.66667H2.83203V5.58334H3.7487V8.33334ZM2.83203 11.0833H4.48203L2.83203 13.0083V13.8333H5.58203V12.9167H3.93203L5.58203 10.9917V10.1667H2.83203V11.0833ZM7.41536 5.58334V7.41667H20.2487V5.58334H7.41536ZM7.41536 18.4167H20.2487V16.5833H7.41536V18.4167ZM7.41536 12.9167H20.2487V11.0833H7.41536V12.9167Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
